import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IMaintenanceReadingItemModel, IDosageItemModel, IReadingTypeItemModel } from "../models";

@Injectable()
export class ReadingsAndDosagesService {
	constructor(private readonly httpService: HttpService) { }

	async getReadingItems(): Promise<IMaintenanceReadingItemModel[]> {
		return await this.httpService.get("/maintenanceHistory/getReadingItemsForSetup");
	}

	async saveReadingItem(model: IMaintenanceReadingItemModel): Promise<IMaintenanceReadingItemModel> {
		return await this.httpService.post("/maintenanceHistory/saveReadingItem", model);
	}

	async deleteReadingItem(maintenanceReadingItemId: number): Promise<boolean> {
		return await this.httpService.delete("/maintenanceHistory/deleteReadingItem", { maintenanceReadingItemId });
	}

	async reorderReadingItems(orderedItemIds: number[]): Promise<boolean> {
		return await this.httpService.post("/maintenanceHistory/reorderReadingItems", orderedItemIds);
	}

	async getReadingTypes(): Promise<IReadingTypeItemModel[]> {
		return await this.httpService.get("/maintenanceHistory/getReadingTypes");
	}

	async saveReadingType(model: IReadingTypeItemModel): Promise<IReadingTypeItemModel> {
		return await this.httpService.post("/maintenanceHistory/saveReadingType", model);
	}

	async deleteReadingType(readingTypeItemId: number): Promise<boolean> {
		return await this.httpService.delete("/maintenanceHistory/deleteReadingType", { readingTypeItemId });
	}

	async getDosageItems(): Promise<IDosageItemModel[]> {
		return await this.httpService.get("/maintenanceHistory/getDosageItems");
	}

	async saveDosageItem(model: IDosageItemModel): Promise<IDosageItemModel> {
		return await this.httpService.post("/maintenanceHistory/saveDosageItem", model);
	}

	async deleteDosageItem(dosageItemId: number): Promise<boolean> {
		return await this.httpService.delete("/maintenanceHistory/deleteDosageItem", { dosageItemId });
	}

	async reorderDosageItems(orderedItemIds: number[]): Promise<boolean> {
		return await this.httpService.post("/maintenanceHistory/reorderDosageItems", orderedItemIds);
	}
}
